import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { routeConfig } from './config'
import Header from 'src/components/Header'
import NotFound from 'src/routes/ErrorPages/NotFound'
import UnauthorizedPage from 'src/routes/ErrorPages/UnauthorizedPage'
import ContentRoute from './ContentRoute'
import { UserDataContext } from 'src/HOCs/withAuth'
import { PageHeaderProvider } from 'src/components/PageHeader/pageHeaderContext'
import ErrorBoundary from 'src/components/ErrorBoundary'
import { RouteLoader } from 'src/components/Loader'
import LayoutWrapper from 'src/components/LayoutWrapper'
import RedirectRoute from 'src/routes/RedirectRoute'
import ActiveThemeWrapper from 'src/components/ActiveThemeWrapper'
import { isAllowed, ADMIN_VIEW_PERMISSIONS } from 'src/utils/permissions'

class Main extends React.Component {
    static contextType = UserDataContext

    mapRouteConfig() {
        return routeConfig.map((route, index) => {
            if (route.redirect) {
                return (
                    <Route
                        key={`${route.name}-${index}`}
                        path={route.path}
                        render={() => <RedirectRoute route={route} />}
                    />
                )
            }

            if (route.permissions instanceof Function) {
                if (!route.permissions(this.context, route.name)) {
                    return (
                        <Route
                            key={`${route.name}-${index}`}
                            path={route.path}
                            component={UnauthorizedPage}
                        />
                    )
                }
            }
            return (
                <ContentRoute
                    key={`${route.component}`}
                    match={this.props.match}
                    exact={route.exact ?? false}
                    path={route.path}
                    component={route.component}
                    title={route.title}
                    name={route.name}
                    breadcrumbs={route.breadcrumbs}
                    options={route.options}
                />
            )
        })
    }

    render() {
        if (!isAllowed(this.context, ADMIN_VIEW_PERMISSIONS)) {
            return <UnauthorizedPage />
        }
        const currentRouteConfig = routeConfig.find(
            item => item.path === window.location.pathname
        )
        const { hideHeader, hideSideMenu, closeSideMenu } = {
            ...currentRouteConfig?.options,
        }

        const Provider = !hideHeader ? PageHeaderProvider : React.Fragment
        return (
            <ActiveThemeWrapper>
                <LayoutWrapper>
                    {!hideSideMenu && (
                        <LayoutWrapper.Left closeSideMenu={closeSideMenu} />
                    )}
                    <Provider>
                        <LayoutWrapper.Main>
                            {!hideHeader && <Header />}
                            <React.Suspense fallback={<RouteLoader />}>
                                <ErrorBoundary>
                                    <Switch>
                                        {this.mapRouteConfig()}
                                        <Route component={NotFound} />
                                    </Switch>
                                </ErrorBoundary>
                            </React.Suspense>
                        </LayoutWrapper.Main>
                    </Provider>
                    <div id="drawer-portal" />
                </LayoutWrapper>
            </ActiveThemeWrapper>
        )
    }
}

export default Main
